module.exports = __webpack_public_path__ + "img/1.ab6f0d01.svg";